// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"698":"27ef6140","726":"f0fcad39"}[chunkId] + ".chunk.js";
};